import { ThemeEvents, CartUpdatedEvent } from '@theme/events';

function getConfig() {
  const el = document.getElementById('mb-cart-auto-gift-config');
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function cartJsonUrl() {
  const base = window.Theme?.routes?.cart_url || '/cart';
  return `${base.replace(/\/$/, '')}.js`;
}

let inFlight = false;

async function syncAutoGift() {
  const config = getConfig();
  if (!config?.giftVariantId || !config?.giftProductId || !config?.sectionId) return;
  if (inFlight) return;

  inFlight = true;
  try {
    const cartRes = await fetch(cartJsonUrl());
    if (!cartRes.ok) return;
    const cart = await cartRes.json();

    const giftVariantId = Number(config.giftVariantId);
    const giftProductId = Number(config.giftProductId);

    const hasGiftLine = cart.items.some((item) => Number(item.variant_id) === giftVariantId);
    const hasOtherProducts = cart.items.some((item) => Number(item.product_id) !== giftProductId);

    if (!hasOtherProducts || hasGiftLine) return;

    const addUrl = window.Theme?.routes?.cart_add_url || '/cart/add.js';
    const addRes = await fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: giftVariantId, quantity: 1 }],
        sections: config.sectionId,
      }),
    });

    if (!addRes.ok) return;

    const data = await addRes.json();

    const cartAfterRes = await fetch(cartJsonUrl());
    let itemCount = cart.item_count + 1;
    if (cartAfterRes.ok) {
      const cartAfter = await cartAfterRes.json();
      itemCount = cartAfter.item_count;
    }

    document.dispatchEvent(
      new CartUpdatedEvent(
        {},
        {
          itemCount,
          source: 'mb-auto-gift',
          sections: data.sections || {},
        },
      ),
    );
  } catch (e) {
    console.error('[mb-cart-auto-gift]', e);
  } finally {
    inFlight = false;
  }
}

function init() {
  const config = getConfig();
  if (!config) return;

  document.addEventListener(ThemeEvents.cartUpdated, () => {
    queueMicrotask(() => syncAutoGift());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncAutoGift(), { once: true });
  } else {
    syncAutoGift();
  }
}

init();
